import { CommunicationCard as DSCommunicationCard } from '@all-manager/design-system-v2';
import type { CommunicationDatabase } from '../../../../types';
import { useCommunicationCard } from './useCommunicationCard';

type Props = {
  item: CommunicationDatabase;
};

export default function CommunicationCard(props: Props) {
  const hook = useCommunicationCard(props);

  return (
    <DSCommunicationCard
      item={hook.item}
      documents={hook.documents}
    />
  );
}
